<template>
  <!-- KSK022 — nested modifier bottom sheet (P5), kiosk theme 2. -->
  <div
    v-if="show"
    class="modifier-option-overlay"
    :style="styleObject"
    @click.self="onCancel"
  >
    <div class="modifier-option-dialog" role="dialog">
      <div class="modifier-option-content">
        <div class="modal-header">
          <div class="ksk-p5__heading">
            <span class="ksk-p5__eyebrow">{{ $t("kiosk.modifier.customize") }}</span>
            <h2 class="ksk-p5__title">{{ item ? tName(item.item_name) : "" }}</h2>
          </div>
          <button
            type="button"
            class="btn-close-x btn-hide-modal-item-modifier-option"
            :aria-label="$t('kiosk.common.close')"
            @click="onCancel"
          >
            <span class="material-icons-round">close</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="item && item.item_in_mog && item.item_in_mog.modifier_group">
            <section
              v-for="(subModifierGroup, index3) in item.item_in_mog.modifier_group"
              :key="index3"
              class="sub-modifier-group ksk-mod-group"
            >
              <div class="ksk-mod-group__head">
                <h3 class="ksk-mod-group__name">{{ tName(subModifierGroup.name) }}</h3>
                <span
                  class="ksk-mod-group__pill"
                  :class="{ 'ksk-mod-group__pill--required': subModifierGroup.min_qty > 0 }"
                >
                  {{ $t(subModifierGroup.min_qty == 0 ? "kiosk.modifier.optional" : "kiosk.modifier.required") }}
                </span>
                <span
                  v-if="ruleText(subModifierGroup)"
                  class="ksk-mod-group__rule"
                  :class="{ 'select-min': isUnmet(subModifierGroup) }"
                >
                  {{ ruleText(subModifierGroup) }}
                </span>
              </div>

              <div class="ksk-mod-grid">
                <div
                  v-for="(subItem, index4) in subModifierGroup.items"
                  :key="index4"
                  class="ksk-opt"
                  :class="{
                    'ksk-opt--selected': subItem.selected,
                    'ksk-opt--sold-out': subItem.is_not_available,
                    'ksk-opt--at-max':
                      subModifierGroup.max_qty > 1 &&
                      subModifierGroup.max_qty == subModifierGroup.total_selected
                        ? !(subModifierGroup.items_selected || []).includes(index4)
                        : false,
                  }"
                  @click="handleSubItemClick(subItem, subModifierGroup, index3, index4)"
                >
                  <span
                    class="ksk-opt__mark material-icons-round"
                    :class="isSingle(subModifierGroup) ? 'ksk-opt__mark--radio' : 'ksk-opt__mark--check'"
                  >check</span>

                  <img
                    v-if="subItem.image && checkImage(subItem.image)"
                    :src="subItem.image"
                    alt=""
                    class="ksk-opt__img"
                  />

                  <div class="ksk-opt__body">
                    <span class="ksk-opt__name">{{ tName(subItem.item_name) }}</span>
                    <span
                      v-if="branch && branch.show_mog_description_on_kiosk && subItem.description"
                      class="ksk-opt__desc"
                    >{{ subItem.description }}</span>
                    <span v-if="subItem.is_not_available" class="ksk-opt__sold-out">{{ $t("kiosk.common.soldOut") }}</span>

                    <div
                      v-if="subItem.selected && subItem.item_max_qty > 1 && subModifierGroup.max_qty > 1"
                      class="ksk-opt__actions"
                    >
                      <div class="ksk-opt__stepper" @click.stop>
                        <button
                          type="button"
                          :aria-label="$t('kiosk.common.decrease')"
                          @click="handleSubQuantityRemove(subItem, subModifierGroup, index3, index4)"
                        >
                          <span class="material-icons-round">remove</span>
                        </button>
                        <span class="ksk-opt__qty">{{ subItem.quantity }}</span>
                        <button
                          type="button"
                          :aria-label="$t('kiosk.common.increase')"
                          @click="handleSubQuantityAdd(index3, index4)"
                        >
                          <span class="material-icons-round">add</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <span v-if="subItem.price > 0" class="ksk-opt__price">
                    +${{ formatPrice(subItem.price_default) }}
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn-modal btn-cancel" @click="onCancel">{{ $t("kiosk.common.cancel") }}</button>
          <button
            class="btn-modal btn-confirm"
            :class="{ disabled: isConfirmDisabled }"
            :disabled="isConfirmDisabled"
            @click="onConfirm"
          >
            {{ $t("kiosk.common.confirm") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localStorageName } from "@/config/utils";
import { translatedName } from "@/i18n/menuTranslate";

export default {
  name: "ModalItemModifierOption",
  data() {
    return {
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO")) || "null"
      ),
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    indexChoice: {
      type: Number,
      default: -1,
    },
    index: {
      type: Number,
      default: -1,
    },
    index2: {
      type: Number,
      default: -1,
    },
    selectOnlyItem: {
      type: Function,
      default: () => {},
    },
    selectMultiItem: {
      type: Function,
      default: () => {},
    },
    addModifierOptionGroup: {
      type: Function,
      default: () => {},
    },
    removeModifierOptionGroup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
    // Disable Confirm if any sub-modifier group violates its min_qty / max_qty.
    isConfirmDisabled() {
      if (
        !this.item ||
        !this.item.item_in_mog ||
        !Array.isArray(this.item.item_in_mog.modifier_group)
      ) {
        return false;
      }
      return this.item.item_in_mog.modifier_group.some((group) => {
        const minQty = parseInt(group.min_qty) || 0;
        const maxQty = parseInt(group.max_qty) || 0;
        const totalSelected = parseInt(group.total_selected) || 0;

        // Compulsory:  not enough min
        if (minQty > 0 && totalSelected < minQty) return true;
        // Over max (applies to both Optional and Compulsory)
        if (maxQty > 0 && totalSelected > maxQty) return true;

        return false;
      });
    },
  },
  methods: {
    tName(source) {
      return translatedName(source);
    },
    formatPrice(price) {
      return new Intl.NumberFormat("en", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(price);
    },
    checkImage(image) {
      return image && !image.includes("noimage.png");
    },
    isSingle(group) {
      return group.min_qty == 1 && group.max_qty == 1;
    },
    isUnmet(group) {
      return group.min_qty > (group.total_selected || 0);
    },
    ruleText(group) {
      const min = group.min_qty;
      const max = group.max_qty;
      if (min == 0 && max > 0) return this.$t("kiosk.modifier.chooseUpTo", { max });
      if (min == 1 && max == 1) return this.$t("kiosk.modifier.chooseOne");
      if (min == max && max > 1) return this.$t("kiosk.modifier.chooseExact", { max, selected: group.total_selected || 0 });
      if (max > 0) return this.$t("kiosk.modifier.chooseRange", { min, max });
      return "";
    },
    handleSubItemClick(subItem, subModifierGroup, index3, index4) {
      if (subItem.is_not_available) return;

      if (subModifierGroup.min_qty === 1 && subModifierGroup.max_qty === 1) {
        this.selectOnlyItem(
          this.indexChoice,
          this.index,
          this.index2,
          subItem,
          index3,
          index4
        );
      } else {
        if (
          !subItem.selected &&
          subModifierGroup.total_selected >= subModifierGroup.max_qty
        ) {
          return;
        }
        this.selectMultiItem(
          this.indexChoice,
          this.index,
          this.index2,
          subItem,
          index3,
          index4
        );
      }
    },
    handleSubQuantityAdd(index3, index4) {
      this.addModifierOptionGroup(
        this.indexChoice,
        this.index,
        this.index2,
        index3,
        index4
      );
    },
    handleSubQuantityRemove(subItem, subModifierGroup, index3, index4) {
      if (subItem.quantity === 1) {
        if (subModifierGroup.min_qty === 1 && subModifierGroup.max_qty === 1) {
          return;
        }
        this.selectMultiItem(
          this.indexChoice,
          this.index,
          this.index2,
          subItem,
          index3,
          index4
        );
      } else {
        this.removeModifierOptionGroup(
          this.indexChoice,
          this.index,
          this.index2,
          index3,
          index4
        );
      }
    },
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
/* KSK022 — nested modifier bottom sheet (P5), kiosk theme 2. */
.modifier-option-overlay {
  position: fixed;
  inset: 0;
  background: var(--ksk-scrim, rgba(20, 26, 20, 0.45));
  z-index: 11000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: modifierOverlayFadeIn 0.2s ease-out;
}

/* Sheet: full width, as tall as its content up to 85% of the screen (was a
   fixed 70%, mostly empty for short groups), 32px top corners. */
.modifier-option-dialog {
  width: 100%;
  max-height: calc(var(--ksk-vh, 1vh) * 85);
  display: flex;
  animation: modifierSheetUp 0.32s cubic-bezier(0.22, 1, 0.36, 1);
}

.modifier-option-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  background: var(--ksk-background);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--ksk-shadow-float);
  font-family: var(--ksk-font);
  color: var(--ksk-text);
  overflow: hidden;
}

@keyframes modifierOverlayFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes modifierSheetUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .modifier-option-overlay,
  .modifier-option-dialog {
    animation: none;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-3);
  background: var(--ksk-surface);
  border-bottom: 1px solid var(--ksk-border);
  flex-shrink: 0;
}
.ksk-p5__heading {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ksk-p5__eyebrow {
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 600;
  color: var(--ksk-text-secondary);
}
/* Long item names stop at 2 lines with an ellipsis. */
.ksk-p5__title {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
  color: var(--ksk-text);
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.btn-close-x {
  width: 56px;
  height: 56px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.btn-close-x:active {
  transform: scale(0.94);
}
.btn-close-x .material-icons-round {
  font-size: 30px;
}

.modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--ksk-space-2) var(--ksk-space-3);
}

.modal-footer {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-2) var(--ksk-space-3) var(--ksk-space-3);
  background: var(--ksk-surface);
  border-top: 1px solid var(--ksk-border);
  flex-shrink: 0;
}
.btn-modal {
  flex: 1;
  height: 80px;
  margin: 0;
  border: 2px solid transparent;
  border-radius: var(--ksk-radius-pill);
  font-family: var(--ksk-font);
  font-size: var(--ksk-label-size);
  font-weight: 600;
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.btn-modal:active:not(:disabled) {
  transform: scale(0.97);
}
/* Quiet secondary, like No in the kiosk confirm dialog. */
.btn-cancel {
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
}
.btn-confirm {
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
  box-shadow: var(--ksk-shadow-float);
}
.btn-confirm.disabled,
.btn-confirm:disabled {
  background: var(--ksk-surface-muted);
  color: var(--ksk-text-secondary);
  box-shadow: none;
  cursor: not-allowed;
}

/* Groups + option tiles — same look as KioskItemModifierNew (P4). */
.sub-modifier-group + .sub-modifier-group {
  margin-top: var(--ksk-space-2);
}
.ksk-mod-group {
  padding: var(--ksk-space-3);
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: var(--ksk-shadow-card);
}
.ksk-mod-group__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: var(--ksk-space-2);
}
.ksk-mod-group__name {
  margin: 0;
  font-family: var(--ksk-font);
  font-size: 26px;
  line-height: 34px;
  font-weight: 700;
  color: var(--ksk-text);
  overflow-wrap: break-word;
}
.ksk-mod-group__pill {
  flex: none;
  padding: 4px 14px;
  border: 1px solid var(--ksk-border);
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-primary-container);
  color: var(--ksk-primary);
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
}
.ksk-mod-group__pill--required {
  border-color: var(--ksk-error);
  background: var(--ksk-error);
  color: var(--ksk-on-status);
}
.ksk-mod-group__rule {
  margin-left: auto;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: var(--ksk-text-secondary);
}
.ksk-mod-group__rule.select-min {
  color: var(--ksk-error);
  font-weight: 600;
}

.ksk-mod-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
}
.ksk-opt {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 88px;
  padding: 12px var(--ksk-space-2);
  border: 2px solid transparent;
  border-radius: 18px;
  background: var(--ksk-background);
  cursor: pointer;
  user-select: none;
  transition: transform 80ms ease-out, opacity 150ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.ksk-opt:active {
  transform: scale(0.98);
}
.ksk-opt--selected {
  border-color: var(--ksk-primary);
  background: var(--ksk-primary-container);
}
.ksk-opt--at-max,
.ksk-opt--sold-out {
  opacity: 0.4;
}
.ksk-opt--sold-out {
  cursor: not-allowed;
}
.ksk-opt__mark {
  flex: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-surface);
  border: 2px solid var(--ksk-border);
  color: transparent;
  font-size: 22px;
}
.ksk-opt__mark--radio {
  border-radius: 50%;
}
.ksk-opt__mark--check {
  border-radius: 10px;
}
.ksk-opt--selected .ksk-opt__mark {
  border-color: var(--ksk-primary);
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-opt__img {
  flex: none;
  width: 120px;
  height: 120px;
  border-radius: 16px;
  object-fit: cover;
}
.ksk-opt__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ksk-opt__name {
  font-size: 21px;
  line-height: 27px;
  font-weight: 600;
  overflow-wrap: break-word;
}
.ksk-opt--selected .ksk-opt__name {
  font-weight: 700;
  color: var(--ksk-primary);
}
.ksk-opt__desc {
  font-size: 16px;
  line-height: 22px;
  color: var(--ksk-text-secondary);
}
.ksk-opt__sold-out {
  align-self: flex-start;
  padding: 2px 12px;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-error);
  color: var(--ksk-on-status);
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
}
.ksk-opt__price {
  flex: none;
  padding: 2px 12px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: var(--ksk-on-primary);
  font-variant-numeric: tabular-nums;
  /* KSK081: theme pill; text black/white by theme lightness (--ksk-on-primary). */
  background: var(--ksk-primary);
  border-radius: var(--ksk-radius-pill);
}
.ksk-opt__actions {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.ksk-opt__stepper {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 52px;
  padding: 0 4px;
  border-radius: var(--ksk-radius-pill);
  background: var(--ksk-surface);
  border: 1px solid var(--ksk-border);
}
.ksk-opt__stepper button {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
}
.ksk-opt__stepper button:last-child {
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-opt__stepper .material-icons-round {
  font-size: 26px;
}
.ksk-opt__qty {
  min-width: 36px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
</style>
